<template>
  <div class="padding" :class="{'disable-ske': !loading}">
    <!-- <div class="d-flex">
      <FormSelect
        v-model="selectedStatus"
        class="sm form-element form-select"
        :options="statusOptions"
        label="Status"
      />
      <FormDatePicker
        v-model="date"
        class="sm form-element ml-md-3"
        id="orderNumber"
        label="From Date"
        :range="true"

        @input="handleDate"
      />
    </div> -->

    <ComposableTable v-if="showTable"
      id="orders-composable-table"
      :disableIsLoadingTalueResult="true"
      :data="ordersData"
      :columns="tableColumns"
      :variables="tableVariables"
      :loading="loading"
    />

    <div class="pagination d-flex justify-content-center" v-if="!loading">
      <Pagination :max="max" :value="page" @input="(p) => (page = p)" />
    </div>
  </div>
</template>

<script>

import FormInput from "@/components/Inputs/FormInput.vue"
import FormSelect from "@/components/Inputs/FormSelect.vue"
import FormDatePicker from "@/components/Inputs/FormDatePicker.vue"
import ComposableTable from "../../ComposableTable/ComposableTable.vue"
import Pagination from "@/layout/Pagination.vue"

export default {
  components: {
    FormSelect,
    FormDatePicker,
    FormInput,
    ComposableTable,
    Pagination,
  },
  props: {
    isActive: Boolean,
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showTable: true,

      ordersData: null,
      page: 1,
      total: 1,
      statusOptions: [
        {
          str: "All",
          value: null,
        },
        {
          str: "Not Sent",
          value: "NOT_SENT",
        },
        {
          str: "Sent to PostNL",
          value: "SENT_TO_POSTNL",
        },
        {
          str: "Shipped",
          value: "SHIPPED",
        },
        {
          str: "Canceled",
          value: "CANCELED",
        },
      ],
      selectedStatus: null,
      dateRange: [],
      date: null,
      tableColumns: [
        "#",
        "Site",
        "Order Date",
        "Order Amount",
        "Customer",
        "State",
      ],
      tableVariables: [
        "orderNumber",
        "site",
        "orderDate",
        "orderAmount",
        "customer",
        "state",
      ],
      loading: false,
    }
  },

  computed: {
    max() {
      return Math.ceil(this.total / 10);
    },
  },

  watch: {
    isActive() {
      this.showTable = false
      this.$nextTick(() => this.showTable = true)
    },
    selectedStatus() {
      this.fetchOrders();
    },
    dateRange(orderDate) {
      if (orderDate.length > 1) this.fetchOrders();
    },
    page() {
      this.fetchOrders();
    }
  },

  mounted() {
    this.fetchOrders();
  },

  methods: {
    async fetchOrders() {
      this.loading = true;

      await this.axios
        .get(`/api/products/${this.productId}/orders`, {
          params: {
            page: this.page
          },
        })
        .then(({ data: { results, total } }) => {
          this.ordersData = results;
          this.total = total;
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },

    handleDate(date) {
      this.dateRange = date;
    },

    // function do make query params
    makeQueryParams() {
      const params = {};

      if (this.selectedStatus) {
        params.status = this.selectedStatus;
      }

      if (this.dateRange) {
        params.orderDate = this.dateRange;
      }

      return params;
    },
  },
};
</script>

<style scoped>

.form-select {
  width: 150px !important;
}

</style>
